import { removeEmptyEntries } from '../..';
import tracker from '../TrackingService';

export const sendMixPanelFilterEvent = ({ filterType, starsCount }) => {
    if (!filterType) {
        return;
    }

    tracker.sendMixPanelEvent({
        eventName: Events.filterClick.Mixpanel,
        eventPayload: removeEmptyEntries({
            'Filter Type': filterType,
            'Stars Count': starsCount,
        }),
    });
};

export const Events = {
    filterClick: {
        Mixpanel: 'Clicked Reviews Filter',
    },
};
